import React from "react";
import "../App.css";
import { Link } from "react-router-dom";
import BackgroundAnimate from "./backgroundAnimate.jsx";
import Projects from "./projects.jsx";
import Technologies from "./technologies.jsx";
import Contact from "./contact.jsx";
import About from "./about.jsx";
import Experience from "./experience.jsx";
import { useLanguage } from "../utils/LanguageContext";
import { useTheme } from "../utils/ThemeContext";
import { FaDownload } from "react-icons/fa";
import useScrollReveal from "../utils/useScrollReveal";

const Main = () => {
  const { language, t } = useLanguage();
  const { theme } = useTheme();

  useScrollReveal(theme, language);

  const cvUrl = language === "en" ? "/MWAFRIKA_CV_EN.pdf" : "/MWAFRIKA_CV_FR.pdf";

  const greeting = language === "en" ? "Hi there," : "Bonjour,";
  const nameIntro = language === "en" ? "I'm MWAFRIKA" : "Je suis MWAFRIKA";

  return (
    <>
      <main className="mx-auto xxxs:px-5 xxs:px-5 xs:px-5 sm:px-5 mt-10 page-enter">

        {/* ── Hero ───────────────────────────────────────────── */}
        <section
          className="grid grid-cols-2 max-w-7xl xxxs:grid-cols-1 xxs:grid-cols-1 xs:grid-cols-1 md:mb-4 min-h-[80vh] items-center"
          id="home"
        >
          <div className="mx-auto my-auto w-full ml-2 relative">
            {/* H1 — staggered reveal (reliable IntersectionObserver) */}
            <h1 className="hero-title-container leading-tight">
              <span className={`reveal block ${theme === "dark" ? "hero-title-dark" : "hero-title"}`}>
                {greeting}
              </span>
              <span className={`reveal reveal-delay-1 block ${theme === "dark" ? "hero-title-dark" : "hero-title"}`}>
                {nameIntro}
              </span>
            </h1>

            <p className="text-xl pb-14 text-gray-400 xxxs:text-lg xxs:text-lg xs:text-lg md:text-xl dark:text-slate-600 max-w-xl reveal reveal-delay-2">
              {t.homeDetails}
            </p>

            <div className="flex gap-x-6 flex-wrap gap-y-4 reveal reveal-delay-3">
              <Link to="/#contact">
                <button
                  type="button"
                  className="btn-press bg-gradient-to-r from-violet-500 to-sky-500 rounded-xl px-8 py-3 font-semibold text-white focus:outline-none focus:ring-2 focus:ring-violet-400 focus:ring-offset-2 focus:ring-offset-slate-900 dark:focus:ring-offset-white"
                >
                  {language === "en" ? "Hire Me" : "M'engager"}
                </button>
              </Link>

              <a
                href={cvUrl}
                download="mwafrika_josue.pdf"
                className="inline-flex items-center gap-2 text-lg underline underline-offset-8 decoration-white/50 dark:decoration-violet-400 dark:text-slate-700 hover:decoration-white dark:hover:decoration-violet-600 transition-all duration-200"
              >
                {language === "en" ? "Download CV" : "Mon CV"}
                <FaDownload aria-hidden="true" className="text-sm" />
              </a>
            </div>
          </div>

          <BackgroundAnimate theme={theme} />
        </section>

        {/* ── Experience ────────────────────────────────────── */}
        <div>
          <Experience />
        </div>

        {/* ── Projects ──────────────────────────────────────── */}
        <div>
          <Projects />
        </div>

        {/* ── Technologies ──────────────────────────────────── */}
        <div>
          <Technologies />
        </div>

        {/* ── About ─────────────────────────────────────────── */}
        <div>
          <About />
        </div>

        <div className="w-full mt-28 border border-slate-50/10 dark:border-slate-200" />

        {/* ── Contact ───────────────────────────────────────── */}
        <div>
          <Contact />
        </div>
      </main>

      <div className="w-full mt-20 border border-slate-50/10 dark:border-slate-200" />
    </>
  );
};

export default Main;
